// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uDDl","content":"styles_content__1xY17","tableWrap":"styles_tableWrap__1YD8Z"};